import React, { useState } from 'react'
import { Checkbox, Tabs } from "antd"
import pluralize from 'pluralize'
import { useHistory, useParams } from 'react-router-dom'

import Modal from "../reusable/modal"
import Receive from '../reusable/receive'
import IssueBatchPicker from './issueBatchPicker'

import { stringifyDate, useListData, usePet, useToggle } from '../../modules'

const { TabPane } = Tabs

const SingleRequest = ({ request, parent, store, i, viewRequest }) => {
    const [quantity, setQuantity] = useState(request.quantity)
    const [batchPicker, toggleBatchPicker] = useToggle()

    const onComplete = ({ }, notif, ops) => {
        notif('Items have been issued', ops('success'))
        toggleBatchPicker()
        viewRequest()
    }

    const [{ loading: issLoading }, issueRequests] = usePet('issueRequests', {
        parent,
        reqId: request?._id,
        quantity
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Issuing items...' } })

    const confirmIssue = batchNo => {
        issueRequests({ parent, reqId: request?._id, quantity, batchNo })
    }

    const onDComplete = ({ }, notif, ops) => {
        notif('Request has been discarded', ops('success'))
        viewRequest()
    }

    const [{ loading: discLoading }, discardRequest] = usePet('discardRequest', {
        parent,
        reqId: request?._id
    }, { notify: true, callback: onDComplete, manual: true, load: { msg: 'Discarding request...' } })

    return (
        <tr key={i}>
            <td className="p-2 pl-4 h-5 text-center">{i + 1}</td>
            <td className="p-2 pl-4 h-5">{request.item.name}</td>
            <td className="p-2 pl-4 h-5">
                {
                    request.issued ? `${request.qtyIssued} ${pluralize(request.item.issuedIn.toLowerCase(), request.qtyIssued)}`
                        : request.discarded ?
                            <div className="text-yellow-500">Discarded</div>
                            :
                            <span className="flex items-center justify-start">
                                <input
                                    className="appearance-none block bg-gray-200 w-24 text-gray-700 border border-gray-200 rounded py-3 px-4 mr-2 leading-tight focus:outline-none focus:bg-white"
                                    // id="grid-qty-item"
                                    defaultValue={request.quantity}
                                    onChange={e => setQuantity(e.target.value, i)}
                                    placeholder={`How many ${request.item.issuedIn.toLowerCase()}?`}
                                    type="number" />
                                <button onClick={() => {
                                    toggleBatchPicker()
                                }} className="text-white hisani-btn-green-light font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center">Issue</button>
                                <button onClick={() => {
                                    discardRequest()
                                }} className="text-white bg-gray-500 hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 font-medium ml-2 rounded-lg text-sm px-3 py-1.5 text-center">Discard</button>
                            </span>
                }
            </td>
            {
                batchPicker &&
                <IssueBatchPicker
                    visible={ batchPicker }
                    toggle={ toggleBatchPicker }
                    itemId={ request?.item?._id }
                    storeId={ store }
                    quantity={ quantity }
                    issuedIn={ request?.item?.issuedIn }
                    loading={ issLoading }
                    onConfirm={ confirmIssue } />
            }
        </tr>
    )
}

const IssueSingleRequest = ({ path = '/app/store', store, onPerform }) => {
    const [request, setRequest] = useState([])

    const [visible, toggle] = useToggle(true)

    const { id, rq } = useParams()

    const history = useHistory()

    const [{ loading, error }, viewRequest] = usePet('viewRequest', {
        id: rq,
        store: id
    }, {
        notify: true, callback: ({ data }) => {
            console.log({ data, store })
            if (data.destination?._id === id)
                setRequest(data)
        }
    })

    const close = () => {
        toggle()
        onPerform()
        setTimeout(() => history.push(`${path}/requests/${id}`), 300)
    }

    return (
        <Modal
            w={ 600 }
            toggle={ close }
            centered={ false }
            visible={ visible }
            title="Issue Request">
            <p className="text-gray-500 text-xs italic">Requested by {request?.requestedBy?.name} on {stringifyDate(request?.date)}</p>
            {
                request &&
                <Tabs defaultActiveKey="0">
                    <TabPane tab="Request" key="0">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                request?.requests?.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2 pl-4 text-center">
                                                    <div className="font-semibold">No.</div>
                                                </th>
                                                <th className="p-2 pl-4 text-left">
                                                    <div className="font-semibold">Item</div>
                                                </th>
                                                <th className="p-2 pl-4 text-left">
                                                    <div className="font-semibold">Stock Level</div>
                                                </th>
                                                <th className="p-2 text-left">
                                                    <div className="font-semibold">Requested</div>
                                                </th>
                                                <th className="p-2 text-left">
                                                    <div className="font-semibold">Issued</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                request.requests.map((rqs, key) =>
                                                    <tr>
                                                        <td className="p-2 pl-4 h-5 text-center">{key + 1}</td>
                                                        <td className="p-2 pl-4 h-5">
                                                            {rqs.item.name}
                                                            { (rqs.discarded || rqs.issued) && <p className="text-gray-500 text-xs italic">{ rqs.discarded ? `Discarded by ${rqs.discardedBy.name}` : rqs.issued ? `Issued by ${rqs.issuedBy.name}` : '' }</p> }
                                                        </td>
                                                        <td className="p-2 pl-4 h-5">
                                                            {
                                                                rqs.issued ?
                                                                    <>
                                                                        <p className="text-gray-500 mb-1 text-xs italic">Before: { (rqs?.entry?.totalBefore ?? 0) } { pluralize(rqs.item.issuedIn, rqs?.entry?.totalBefore ?? 0) }</p>
                                                                        { (!rqs.discarded && rqs.issued) && <p className="text-gray-500 text-xs italic">After: { rqs?.entry?.total ?? 0 } { pluralize(rqs.item.issuedIn, rqs?.entry?.totalBefore ?? 0) }</p> }
                                                                    </>
                                                                :
                                                                    <span className="flex items-center">
                                                                        { rqs.current } { pluralize(rqs.item.issuedIn, rqs.current) }
                                                                    </span>
                                                            }
                                                        </td>
                                                        <td className="p-2 pl-4 h-5">
                                                            <span className="flex items-center">
                                                                {rqs.quantity} { pluralize(rqs.item.issuedIn, rqs.quantity) }
                                                            </span>
                                                        </td>
                                                        <td className="p-2 pl-4 h-5">
                                                            <span className="flex items-center">
                                                                {rqs.qtyIssued ?? 0 } { pluralize(rqs.item.issuedIn, rqs.qtyIssued ?? 0) }
                                                            </span>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    : <div className="align-center flex w-full">
                                        <h2>No items have been requested</h2>
                                    </div>
                            }
                        </Receive>
                    </TabPane>
                    <TabPane tab="Items Issued" key="1">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                request?.requests?.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2 pl-4 text-center">
                                                    <div className="font-semibold">No.</div>
                                                </th>
                                                <th className="p-2 pl-4 text-left">
                                                    <div className="font-semibold">Item</div>
                                                </th>
                                                <th className="p-2 text-left">
                                                    <div className="font-semibold">Quantity Issued</div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                request.requests.map((rqs, i) =>
                                                    <SingleRequest
                                                        i={ i }
                                                        key={ i }
                                                        parent={ rq }
                                                        store={ id }
                                                        request={ rqs }
                                                        viewRequest={ viewRequest } />
                                                )
                                            }
                                        </tbody>
                                    </table>
                                    : <div className="align-center flex w-full">
                                        <h2>No items have been requested</h2>
                                    </div>
                            }
                        </Receive>
                    </TabPane>
                </Tabs>
            }
            <div className="flex justify-end">
                <button disabled={loading} onClick={close} className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Close</button>
            </div>
        </Modal>
    )
}

export default IssueSingleRequest